module.exports = __webpack_public_path__ + "media/bootstrap-icons/pentagon-half-0e006ba8.svg";